module.exports = __webpack_public_path__ + "static/media/needle.9cf8046a.jpg";